<template>
  <div class="introduction">
    <div class="pub-center">
      <div class="data-intro-open pub-fix">
        <p class="title">主题统计</p>
        <div class="pub-fl data-item">
          <p class="data-title">主题入驻情况</p>
          <div class="data-set">
            <div class="set-item">
              <p class="count">{{themeCount}}</p>
              <p class="data-set-title">入驻主题数</p>
            </div>
            <div class="set-item">
              <p class="count">{{itemCount}}</p>
              <p class="data-set-title">涉及事项数</p>
            </div>
            <div class="set-item">
              <p class="count">{{unitCount}}</p>
              <p class="data-set-title">部门数</p>
            </div>
          </div>
        </div>
        <div class="pub-fr data-item">
          <p class="data-title">各地区主题入驻情况</p>
          <div id="area-invest"></div>
        </div>
      </div>
      <div class="data-intro-open">
        <p class="title">效能统计</p>
        <div>
          <div class="data-item-2">
            <p class="data-title">减少办理时限</p>
            <div id="time-invest"></div>
          </div>
          <div class="data-item-2">
            <p class="data-title">减少材料收取</p>
            <div id="stuff-invest"></div>
          </div>
        </div>
        <div>
          <div class="data-item-2">
            <p class="data-title">减少跑动次数</p>
            <div id="turn-invest"></div>
          </div>
          <div class="data-item-2">
            <p class="data-title">网办统计</p>
            <div id="control-submit"></div>
          </div>
        </div>

      </div>
      <div class="data-intro-open">
        <p class="title">一件事主题服务简介</p>
        <img src="../../../../../assets/img/intro.png" alt class="intro-img" />
        <!-- <template v-if="introContent.length > 0">
                <div class="intro-conten" v-html="introContent[0].content"></div>
            </template>
            <template v-else>
                <div class="intro-conten">暂无简介内容</div>
        </template>-->
      </div>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
import {
  inThemeReport,
  inAreaThemeReport,
  statisticsReport,
  loadContentList
} from "@/utils/indexUrl";
export default {
  data() {
    return {
      itemCount: 0, // 涉及事项数
      unitCount: 0, // 单位数
      themeCount: 0, // 入驻主题数
      investOpt: {
        color: ["#0486F5", "#00D597", "#DCEC00"],
        tooltip: {
          trigger: "axis"
        },
        legend: {
          icon: "rect",
          itemHeight: "2",
          data: ["入驻主题数", "涉及事项数", "部门数"],
          textStyle: {
            fontSize: 12, //字体大小
            color: "#ffffff" //字体颜色
          },
          selectedMode: false
        },
        xAxis: [
          {
            type: "category",
            axisTick: { show: false },
            data: [],
            axisLabel: {
              show: true,
              textStyle: {
                color: "#ffffff" //这里用参数代替了
              }
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            name: "数量：项",
            nameTextStyle: {
              color: "#9EA9B6"
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#ffffff" //这里用参数代替了
              }
            }
          }
        ],
        series: [
          {
            name: "入驻主题数",
            type: "bar",
            barGap: 0,
            data: []
          },
          {
            name: "涉及事项数",
            type: "bar",
            data: []
          },
          {
            name: "部门数",
            type: "bar",
            data: []
          }
        ],
        //给x轴设置滚动条
        dataZoom: [
          {
            start: 0, //默认为0
            end: 50,
            type: "slider",
            show: true,
            xAxisIndex: [0],
            handleSize: 0, //滑动条的 左右2个滑动条的大小
            height: 8, //组件高度
            left: "10%", //左边的距离
            right: "10%", //右边的距离
            bottom: 26, //右边的距离
            handleColor: "#ddd", //h滑动图标的颜色
            handleStyle: {
              borderColor: "#cacaca",
              borderWidth: "1",
              shadowBlur: 2,
              background: "#ddd",
              shadowColor: "#ddd"
            },
            fillerColor: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
              {
                //给颜色设置渐变色 前面4个参数，给第一个设置1，第四个设置0 ，就是水平渐变
                //给第一个设置0，第四个设置1，就是垂直渐变
                offset: 0,
                color: "#1eb5e5"
              },
              {
                offset: 1,
                color: "#5ccbb1"
              }
            ]),
            backgroundColor: "#ddd", //两边未选中的滑动条区域的颜色
            showDataShadow: false, //是否显示数据阴影 默认auto
            showDetail: false, //即拖拽时候是否显示详细数值信息 默认true
            handleIcon:
              "M-292,322.2c-3.2,0-6.4-0.6-9.3-1.9c-2.9-1.2-5.4-2.9-7.6-5.1s-3.9-4.8-5.1-7.6c-1.3-3-1.9-6.1-1.9-9.3c0-3.2,0.6-6.4,1.9-9.3c1.2-2.9,2.9-5.4,5.1-7.6s4.8-3.9,7.6-5.1c3-1.3,6.1-1.9,9.3-1.9c3.2,0,6.4,0.6,9.3,1.9c2.9,1.2,5.4,2.9,7.6,5.1s3.9,4.8,5.1,7.6c1.3,3,1.9,6.1,1.9,9.3c0,3.2-0.6,6.4-1.9,9.3c-1.2,2.9-2.9,5.4-5.1,7.6s-4.8,3.9-7.6,5.1C-285.6,321.5-288.8,322.2-292,322.2z",
            filterMode: "filter"
          },
          //下面这个属性是里面拖到
          {
            type: "inside",
            show: true,
            xAxisIndex: [0],
            start: 0, //默认为1
            end: 50
          }
        ]
      },
      InvestChart: null,
      introContent: [], // 简介内容
      timeOpt: {
        color: ["#0486F5"],
        textStyle: {
          color: "#ffffff" //这里用参数代替了
        },
        xAxis: [
          {
            type: "category",
            data: ["周一", "周二", "周三", "周四", "周五", "周六", "周日"],
            axisLabel: {
              show: true,
              textStyle: {
                color: "#ffffff" //这里用参数代替了
              }
            }
          }
        ],
        yAxis: [{
          type: "value",
          name: "时限：天",
          nameTextStyle: {
            color: "#9EA9B6"
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#ffffff" //这里用参数代替了
            }
          }
        }],
        series: [
          {
            data: [120, 200, 150, 80, 70, 110, 130],
            type: "bar",
            label: {
              show: true,
              position: 'top'
            },

          }
        ]
      },
      timeChart: null,
      stuffOpt: {
        color: ["#00D597"],
        textStyle: {
          color: "#ffffff" //这里用参数代替了
        },
        xAxis: [
          {
            type: "category",
            data: ["周一", "周二", "周三", "周四", "周五", "周六", "周日"],
            axisLabel: {
              show: true,
              textStyle: {
                color: "#ffffff" //这里用参数代替了
              }
            }
          }
        ],
        yAxis: {
          type: "value",
          name: "数量：件",
          nameTextStyle: {
            color: "#9EA9B6"
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#ffffff" //这里用参数代替了
            }
          }
        },
        series: [
          {
            data: [120, 200, 150, 80, 70, 110, 130],
            type: "bar",
            label: {
              show: true,
              position: 'top'
            },
          }
        ]
      },
      stuffChart: null,
      turnOpt: {
        color: ["#DCEC00"],
        textStyle: {
          color: "#ffffff" //这里用参数代替了
        },
        xAxis: [
          {
            type: "category",
            data: ["周一", "周二", "周三", "周四", "周五", "周六", "周日"],
            axisLabel: {
              show: true,
              textStyle: {
                color: "#ffffff" //这里用参数代替了
              }
            }
          }
        ],
        yAxis: {
          type: "value",
          name: "数量：次",
          nameTextStyle: {
            color: "#9EA9B6"
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#ffffff" //这里用参数代替了
            }
          }
        },
        series: [
          {
            data: [120, 200, 150, 80, 70, 110, 130],
            type: "bar",
            label: {
              show: true,
              position: 'top'
            }
          }
        ]
      },
      turnChart: null,
      controlSubmitOpt: {
        color: ["#CA4444"],
        textStyle: {
          color: "#ffffff" //这里用参数代替了
        },
        xAxis: [
          {
            type: "category",
            data: ["周一", "周二", "周三", "周四", "周五", "周六", "周日"],
            axisLabel: {
              show: true,
              textStyle: {
                color: "#ffffff" //这里用参数代替了
              }
            }
          }
        ],
        yAxis: {
          type: "value",
          name: "数量：次",
          nameTextStyle: {
            color: "#9EA9B6"
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#ffffff" //这里用参数代替了
            }
          }
        },
        series: [
          {
            data: [120, 200, 150, 80, 70, 110, 130],
            type: "bar",
            label: {
              show: true,
              position: 'top'
            }
          }
        ]
      },
      controlSubmitChart: null
    };
  },
  components: {},
  methods: {
    getData() {
      inThemeReport({}, res => {
        if (+res.status == 200) {
          this.itemCount = res.data.itemCount;
          this.unitCount = res.data.unitCount;
          this.themeCount = res.data.themeCount;
        } else {
          this.$message.error(res.desc);
        }
      });
    },
    getAreaData() {
      //获取一件事主题统计各区县
      this.InvestChart = echarts.init(document.getElementById("area-invest"));
      inAreaThemeReport({}, res => {
        if (+res.status == 200) {
          let dataRes = res.data;
          let themeList = [],
            itemList = [],
            unitList = [],
            areaList = [];
          dataRes.forEach(ele => {
            areaList.push(ele.areaName);
            themeList.push(ele.themeNum);
            itemList.push(ele.itemNum);
            unitList.push(ele.unitNum);
          });
          this.investOpt.xAxis[0].data = areaList;
          this.investOpt.series[0].data = themeList;
          this.investOpt.series[2].data = unitList;
          this.investOpt.series[1].data = itemList;
          this.InvestChart.setOption(this.investOpt);
        } else {
          this.$message.error(res.desc);
        }
      });
    },
    getstatisticsData() {
      //获取一件事效能统计
      this.timeChart = echarts.init(document.getElementById("time-invest"));
      this.stuffChart = echarts.init(document.getElementById("stuff-invest"));
      this.turnChart = echarts.init(document.getElementById("turn-invest"));
      this.controlSubmitChart = echarts.init(document.getElementById("control-submit"));

      statisticsReport({}, res => {
        if (+res.status == 200) {
          let timeLimit = res.data.timeLimit;
          let takeStuff = res.data.takeStuff;
          let turnUpTimes = res.data.turnUpTimes;
          let controlSubmit = res.data.controlSubmit;
          let timeName = [],
            timeNum = [],
            stuffName = [],
            stuffNum = [],
            turnName = [],
            turnNum = [],
            controlName = [],
            controlNum = [];
          timeLimit.forEach(ele => {
            timeName.push(ele.name);
            timeNum.push(ele.num);
          });
          takeStuff.forEach(ele => {
            stuffName.push(ele.name);
            stuffNum.push(ele.num);
          });
          turnUpTimes.forEach(ele => {
            turnName.push(ele.name);
            turnNum.push(ele.num);
          });
          controlSubmit.forEach(ele => {
            controlName.push(ele.name);
            controlNum.push(ele.num);
          });

          this.timeOpt.xAxis[0].data = timeName;
          this.timeOpt.series[0].data = timeNum;

          this.stuffOpt.xAxis[0].data = stuffName;
          this.stuffOpt.series[0].data = stuffNum;

          this.turnOpt.xAxis[0].data = turnName;
          this.turnOpt.series[0].data = turnNum;

          this.controlSubmitOpt.xAxis[0].data = controlName;
          this.controlSubmitOpt.series[0].data = controlNum;

          this.timeChart.setOption(this.timeOpt);
          this.stuffChart.setOption(this.stuffOpt);
          this.turnChart.setOption(this.turnOpt);
          this.controlSubmitChart.setOption(this.controlSubmitOpt);

        } else {
          this.$message.error(res.desc);
        }
      });
    },
    getContent() {
      // 获取一次办简介的内容，cms内容发布系统
      loadContentList(
        {
          categoryFlag: "UNION_YJSJJ"
        },
        res => {
          if (+res.status == 200) {
            this.introContent = res.data.dataList;
          } else {
            this.$message.error(res.desc);
          }
        }
      );
    }
  },
  mounted() {
    this.getData();
    this.getAreaData();
    this.getstatisticsData();
    // this.getContent()
  }
};
</script>

<style lang="scss">
.introduction {
  .data-intro-open {
    margin: 35px 0;
    padding-bottom: 25px;

    .title {
      font-size: 24px;
      font-weight: 700;
      color: #0d1c28;
      padding-bottom: 16px;
      border-bottom: 2px solid #0d1c28;
    }
    .intro-img {
      margin-top: 24px;
    }
    .data-item {
      width: 587px;
      height: 222px;
      background: linear-gradient(
        180deg,
        rgba(17, 73, 122, 1) 0%,
        rgba(8, 56, 97, 1) 100%
      );
      border-radius: 2px;
      padding: 20px 0;
      margin-top: 24px;
      display: inline-block;

      &:last-child {
        margin-left: 26px;
      }

      .data-set {
        margin-top: 40px;
        color: #ffffff;

        .set-item {
          width: 33%;
          text-align: center;
          border-right: 1px solid #4a698e;
          border-radius: 1px;
          display: inline-block;

          .count {
            font-size: 42px;
            color: #ffffff;
            line-height: 49px;
          }

          .data-set-title {
            font-size: 14px;
            font-weight: 400;
            color: #9ea9b6;
            margin-top: 8px;
          }

          &:last-child {
            border-right: 0;
          }
        }
      }

    }

    #area-invest, #time-invest, #stuff-invest, #turn-invest, #control-submit {
      width: 100%;
      height: 200px;
    }

    .data-title {
      font-size: 16px;
      font-weight: 400;
      color: #ffffff;
      line-height: 22px;
      padding-left: 20px;
    }

    .data-item-3 {
      width: 383px;
      height: 230px;
      margin-right: 25px;
      display: inline-block;
      border-radius: 2px;
      margin-top: 24px;
      padding: 20px 0;
      background: linear-gradient(
        180deg,
        rgba(17, 73, 122, 1) 0%,
        rgba(8, 56, 97, 1) 100%
      );
      &:last-child {
        margin-right: 0;
      }
    }

    .data-item-2 {
      width: 587px;
      height: 230px;
      margin-right: 26px;
      display: inline-block;
      border-radius: 2px;
      margin-top: 24px;
      padding: 20px 0;
      background: linear-gradient(
          180deg,
          rgba(17, 73, 122, 1) 0%,
          rgba(8, 56, 97, 1) 100%
      );
      &:last-child {
        margin-right: 0;
      }
    }

    .intro-conten {
      margin-top: 24px;
      text-align: center;
    }
  }
}
</style>
